var exports = {
  "kL": "GroupInvitesModal.module__container___UTkxNX",
  "CR": "GroupInvitesModal.module__modalRoot___UTkxNX" + " " + __webpack_require__(278365)["root"] + " " + __webpack_require__(278365)["large"],
  "dc": "GroupInvitesModal.module__spinnerContainer___UTkxNX",
  "Ye": "GroupInvitesModal.module__errorBox___UTkxNX",
  "kc": "GroupInvitesModal.module__errorText___UTkxNX",
  "Zb": "GroupInvitesModal.module__stateBox___UTkxNX",
  "r9": "GroupInvitesModal.module__stateText___UTkxNX",
  "Mp": "GroupInvitesModal.module__invitesWrapper___UTkxNX",
  "$h": "GroupInvitesModal.module__invitesList___UTkxNX",
  "XG": "GroupInvitesModal.module__scroller___UTkxNX",
  "eu": "GroupInvitesModal.module__inviteItems___UTkxNX",
};

module.exports = exports;
